import { useCallback } from "react";

/**
 * Hook to format a Date object into a string, with optional pattern.
 * Supported formats:
 * - "date" → "yyyy-mm-dd"
 * - "datetime" → "yyyy/mm/dd hh:mm"
 */
const useFormattedLocalDate = () => {
  return useCallback((date, format = "date") => {
    if (!(date instanceof Date) || isNaN(date)) return "";

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    if (format === "datetime") {
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    }

    // default: "yyyy-mm-dd"
    return `${year}-${month}-${day}`;
  }, []);
};

export default useFormattedLocalDate;
